import React, { useState } from "react";


const departments = [
    { "name": "परिचय", "id": "about" },
    { "name": "शोध परियोजनाएं", "id": "researchProjects" },
    { "name": "सेमीनार/सम्मेलन/कार्यशाला", "id": "seminarsWorkshops" },
    { "name": "शोधार्थी", "id": "researchScholars" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

const departmentContent = {
    "about": (
        <div>
            <h5 className="mb-3" style={{ textAlign: 'center', color: '#77236B' }}>शोध केंद्र के बारे में</h5>
            <h6 className="mb-3 text-secondary">परिचय</h6>
            <p className="mb-2 text-justify">हरियाणा की भूमि भारतीय सांस्कृतिक एवं ज्ञान परम्परा को अपने आप में समेटे है। प्राचीन से अर्वाचीन पर्यन्त ज्ञान का यहाँ अजस्र प्रवाह रहा है। चाहे विशिष्ट वैदिक शाखा के प्रणयन के साक्ष्य हों या पुरातात्विक दृष्टि से भी ज्ञान परम्परा के उद्घोष के पक्ष हों। प्रत्येक दृष्टि से हरियाणा के कपिस्थल की भूमि अपनी ज्ञानिक उर्वरता के लिए जगश्रुत रही है। महर्षि वाल्मीकि के कार्यक्षेत्र में होने के भी पर्याप्त प्रमाण उपलब्ध है तथा महर्षि वाल्मीकि के नाम पर ही इस विश्वविद्यालय की स्थापना हुई है। एतदर्थ आवश्यकता है कि महर्षि वाल्मीकि के कृतित्व का बोध जनमानस में हो। इसलिए विश्वविद्यालय महर्षि वाल्मीकि शोध पीठ के रूप में अपना पदक्षेपण ले चुका है।</p>
            <p className="mb-4 text-justify">महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल के द्वारा शैक्षणिक सत्र 2022-23 में महर्षि वाल्मीकि शोध पीठ की स्थापना की गई, जिसका उद्घाटन दिनांक 08-10-2022 को श्री कृष्ण कुमार बेदी, कैबिनेट मन्त्री, हरियाणा सरकार के द्वारा किया गया।</p>

            <h6 className="mb-3 text-secondary">शोध पीठ के उद्देश्य एवं कार्य</h6>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">• महर्षि वाल्मीकि जी द्वारा रचित ग्रन्थों का संकलन एवं महर्षि वाल्मीकि से सम्बन्धित समस्त शोध कार्यों का संकल्न करना।</li>
                <li className="list-group-item bg-transparent border-0">• महर्षि वाल्मीकि जी से सम्बन्धित शोध कार्यों को करवाना।</li>
                <li className="list-group-item bg-transparent border-0">• सामाजिक समरसता का उद्भव एवं विकास करना।</li>
                <li className="list-group-item bg-transparent border-0">• राष्ट्रीय एवं अन्तर्राष्ट्रीय स्तर पर किए गए महर्षि वाल्मीकि द्वारा रचित रामायण का संकलन करना।</li>
            </ul>
        </div>
    ),
    "researchProjects": (
        <div>
            <h5 className="mb-3" style={{ textAlign: 'center', color: '#77236B' }}>शोध परियोजनाएं</h5>
            <p className="text-muted text-justify">शोध परियोजनाओं की जानकारी जल्द ही उपलब्ध कराई जाएगी।</p>
            {/* You can add specific research project details here when available */}
        </div>
    ),
    "seminarsWorkshops": (
        <div>
            <h5 className="mb-3" style={{ textAlign: 'center', color: '#77236B' }}>सेमीनार/सम्मेलन/कार्यशाला</h5>
            <h6 className="mb-3 text-secondary">शोध पीठ द्वारा आयोजित कार्यक्रम</h6>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">• दिनांक 3 जुलाई 2023 को विश्वविद्यालय के टीक परिसर में गुरु पूर्णिमा (व्यास पूर्णिमा) के अवसर पर एक दिवसीय कार्यक्रम का आयोजन किया गया। कार्यक्रम के मुख्यातिथि प्रसिद्ध संस्कृत विद्वान् एवं विश्वेश्वरानन्द वैदिक शोध संस्थान के पूर्व निदेशक प्रो. जगदीश प्रसाद सेमवाल, अध्यक्ष विश्वविद्यालय के कुलपति प्रो. रमेश चन्द्र भारद्वाज तथा संयोजक डॉ. सुरेन्द्र पाल वत्स रहे।</li>
                <li className="list-group-item bg-transparent border-0">• दिनांक 26 से 28 अक्टूबर 2023 को विश्वविद्यालय में महर्षि वाल्मीकि जयन्ती महोत्सव का आयोजन किया गया। इस अवसर पर विश्वविद्यालय में “महर्षि वाल्मीकि जीवन दर्शन-योगवासिष्ठ के परिप्रेक्ष्य में” विषय पर द्वि-दिवसीय अन्तर्राष्ट्रीय संगोष्ठी का आयोजन किया गया। प्रथम दिवसीय कार्यक्रम में मुख्य अतिथि प्रो. ओमनाथ बिमली (दिल्ली विश्वविद्यालय), सारस्वत अतिथि प्रो. रमेश कुमार पाण्डेय (पूर्व कुलपति, श्री लाल बहादुर शास्त्री केन्द्रीय संस्कृत विश्वविद्यालय, नई दिल्ली), मुख्य अतिथि प्रो. माधव अधिकारी (कुलसचिव, नेपाल संस्कृत विश्वविद्यालय) तथा अध्यक्ष प्रो. रमेश चन्द्र भारद्वाज (कुलपति, म.वा.सं.वि.वि. कैथल) रहे। महर्षि वाल्मीकि संस्कृत विश्वविद्यालय एवं नेपाल संस्कृत विश्वविद्यालय के बीच दिनांक 27 अक्टूबर 2023 को एमओयू किया जिसके माध्यम से दोनों विश्वविद्यालयों के बीच कार्यशालाएं, संगोष्ठी, सम्मेलन इत्यादि में अकादमिक सहयोग, शिक्षकों एवं छात्रों के आदान-प्रदान के कार्यक्रमों का आयोजन, संयुक्त रूप से शोधकार्य एवं अनेक शैक्षणिक गतिविधियों का आयोजन, विद्यावारिधि (पीएचडी) एवं मास्टर डिग्री के पाठ्यक्रमों के संयुक्त रूप से संचालन जैसे कार्यों की रूपरेखा तैयार की गई।</li>
                <li className="list-group-item bg-transparent border-0">• 20 जनवरी 2024 को विश्वविद्यालय के महर्षि वाल्मीकि शोध पीठ द्वारा “भारतीय संस्कृति के आधार: महर्षि वाल्मीकि के राम” विषय पर एकदिवसीय संगोष्ठी का आयोजन किया गया। इस संगोष्ठी में मुख्य वक्ता डॉ. प्रीतम सिंह (सह-निदेशक, डॉ. भीमराव अम्बेडकर अध्ययन केन्द्र, कुरुक्षेत्र विश्वविद्यालय), श्री श्याम बंसल (वरिष्ठ समाजसेवी एवं राष्ट्रीय स्वयंसेवक संघ के जिला संघचालक), श्री रविभूषण गर्ग (वरिष्ठ शिक्षाविद् एवं समाजसेवी) एवं अध्यक्ष रूप में माननीय कुलपति प्रो. रमेश चन्द्र भारद्वाज उपस्थित रहे।</li>
                <li className="list-group-item bg-transparent border-0">• 21 जुलाई, 2024 को महर्षि वाल्मीकि संस्कृत विश्वविद्यालय के महर्षि वाल्मीकि शोध पीठ द्वारा महर्षि व्यास जन्मोत्सव (गुरु पूर्णिमा) के शुभ अवसर पर महर्षि व्यास की कर्म एवं तपःस्थली यमुनानगर जनपद में श्री कालेश्वर महादेव मन्दिर (यमुना तट) में एक दिवसीय कार्यक्रम का आयोजन किया गया। कार्यक्रम के अध्यक्ष विश्वविद्यालय के माननीय कुलपति प्रो. रमेश चन्द्र भारद्वाज, मुख्य अतिथि एडवोकेट श्री मुकेश गर्ग (सदस्य, हरियाणा इलेक्ट्रसिटी रेगुलेटरी कमीशन), मुख्य वक्ता प्रो. जे. पी. सेमवाल (पूर्व निदेशक, वी.वी.आर.आई., होशियारपुर, पंजाब), विशिष्ट अतिथि डॉ. नक्षत्रपाल सिंह (स्टार एक्स विश्वविद्यालय, गुरुग्राम), श्री कालेश्वर महादेव मन्दिर के अध्यक्ष स्वामी शान्ता नन्द सरस्वती एवं महर्षि वाल्मीकि शोध पीठ संयोजक डॉ. हरीश कुमार उपस्थित रहे।</li>
                <li className="list-group-item bg-transparent border-0">• 17 अक्टूबर 2024 महर्षि वाल्मीकि जयन्ती के अवसर पर सामूहिक यज्ञ के पश्चात् ‘वाल्मीकीय रामायण में गुरु शिष्य परम्परा’ विषय पर संगोष्ठी का आयोजन किया गया। जिसमें मुख्य अतिथि प्रो. जगदीश प्रसाद सेमवाल (पूर्व निदेशक, विश्वेश्वरानन्द वैदिक शोध संस्थान, होशियारपुर, पंजाब), मुख्य वक्ता, प्रो. कृष्णा देवी (अध्यक्षा, संस्कृत विभाग, कुरुक्षेत्र विश्वविद्यालय), अध्यक्ष के रूप में विश्वविद्यालय के कुलपति प्रो. रमेश चन्द्र भारद्वाज एवं कार्यक्रम संयोजक डॉ. रामानन्द मिश्र रहे।</li>
                <li className="list-group-item bg-transparent border-0">• दिनांक 29 जनवरी, 2025 को महर्षि वाल्मीकि संस्कृत विश्वविद्यालय के महर्षि वाल्मीकि शोध पीठ एवं राज्य सभा फेलोशिप के संयुक्त तत्त्वावधान में ‘सप्त सिन्धु वाल्मीकि समाज और महर्षि वाल्मीकि’ विषय पर एक दिवसीय राष्ट्रीय संगोष्ठी का आयोजन किया गया।</li>
            </ul>
            <h6 className="mb-3 text-secondary">योजनाएं:</h6>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">• 2 अन्तर्राष्ट्रीय सेमीनार, 3 राष्ट्रीय एवं 6 राज्य/विश्वविद्यालयीय सेमीनार/संगोष्ठी/कार्यशालाएं करवाना।</li>
                <li className="list-group-item bg-transparent border-0">महर्षि वाल्मीकि द्वारा रचित ग्रन्थों का संकलन कर पुस्तकों का प्रकाशन करवाना।</li>
            </ul>
        </div>
    ),
    "researchScholars": (
        <div>
            <h5 className="mb-3" style={{ textAlign: 'center', color: '#77236B' }}>शोधार्थी</h5>
            <p className="text-muted text-justify">वर्तमान में कोई शोधार्थी पंजीकृत नहीं है।</p>
            {/* Add actual research scholar details if available */}
        </div>
    ),
    "achievements": (
        <div>
            <h5 className="mb-3" style={{ textAlign: 'center', color: '#77236B' }}>उपलब्धियां</h5>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">
                    महर्षि वाल्मीकि शोध पीठ द्वारा <strong>महर्षि वाल्मीकि का जीवन दर्शन</strong>
                    (योगवासिष्ठ के सन्दर्भ में) पुस्तक का प्रकाशन किया गया,
                    जिसके प्रधान सम्पादक - प्रो. रमेश चन्द्र भारद्वाज
                    (पूर्व कुलपति, महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल),
                    सम्पादक- डॉ. हरीश कुमार (संयोजक, महर्षि वाल्मीकि शोध पीठ) रहे ।
                    पुस्तक का विमोचन<strong> महामहिम राज्यपाल श्री बण्डारु दत्तात्रेय जी</strong> द्वारा
                    <strong>19 मार्च 2025</strong> को विश्वविद्यालय के <strong>प्रथम दीक्षान्त समारोह</strong> में किया गया ।
                </li>

            </ul>
        </div>
    ),
    "contact": (
        <div>
            <h5 className="mb-3" style={{ textAlign: 'center', color: '#77236B' }}>सम्पर्क</h5>

            {/* Academic Staff Contact */}
            <h6 className="mb-3 text-secondary">विभाग में कार्यरत शैक्षणिक कर्मचारी का विवरण</h6>
            <div className="card mb-4 shadow-sm border-0">
                <div className="card-body p-3">
                    <p className="card-text mb-2">
                        <strong className="text-secondary">डॉ. हरीश कुमार</strong><br />
                        संयोजक, महर्षि वाल्मीकि शोध पीठ<br />
                        दूरभाष: <a href="tel:+917988376657" className="text-decoration-none text-dark fw-bold">79883 76657</a><br />
                        ई-मेल: <a href="mailto:mvspeeth@mvsu.ac.in" className="text-decoration-none text-dark fw-bold">mvspeeth@mvsu.ac.in</a>
                    </p>
                </div>
            </div>

            {/* Non-Academic Staff Contact */}
            <h6 className="mb-3 text-secondary">विभाग में कार्यरत गैर-शैक्षणिक कर्मचारी का विवरण</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>क्र.</th>
                            <th>कर्मचारी का नाम</th>
                            <th>पद</th>
                            <th>दूरभाष</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>श्री मुकेश कुमार</td>
                            <td>लिपिक (HKRN)</td>
                            <td><a href="tel:+919592123777" className="text-decoration-none text-dark fw-bold">9592-123-777</a></td>
                            <td><a href="mailto:mvspeeth@mvsu.ac.in" className="text-decoration-none text-dark fw-bold">mvspeeth@mvsu.ac.in</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default function MaharishiValmikiResearchCenter() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about"); // Set initial content

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        setShowSidebar(false); // Hide sidebar on click for small screens
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>


            {/* Sidebar */}
            <aside className={` text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">महर्षि वाल्मीकि शोध केंद्र</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded shadow-sm small transition-all ${activeContentId === dept.id ? "text-white fw-bold" : "bg-white text-dark hover-effect"}`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeContentId === dept.id ? "#77236b" : undefined, // Apply purple when active
                            }}
                            onClick={() => handleItemClick(dept.id)}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto" onClick={() => setShowSidebar(false)}>
                {departmentContent[activeContentId] || <p className="text-muted">कृपया किसी अनुभाग का चयन करें।</p>}
            </main>
        </div>
    );
}
